import { useEffect } from "react";
import { useSelector } from "react-redux";
import SocketService from "../services/socket.service";
import LogRocket from "logrocket";

export default function SocketConnection() {
  const { _id, role, username, email } =
    useSelector((state) => state?.editUser?.user) || {};
  // console.log(_id, role);
  useEffect(() => {
    LogRocket.identify(_id, { username, email });
    // console.log('identify', 'logrocket in socket')
  }, [_id, email, username]);

  useEffect(() => {
    SocketService.connect({ _id, role });

    return () => {
      SocketService.disconnect();
    };
  }, [_id, role]);

  return null;
}
